export const EMPTY = { ret: 0, data: [] }
export const EMPTY_PAGE = { ret: 0, data: {} }